/*
 * @Author: Axs <i@axs.email>
 * @Date: 2021-10-18 17:37:06
 * @LastEditors: Axs <i@axs.email>
 * @LastEditTime: 2022-05-05 14:04:45
 * @Description: 
 * @FilePath: /src/main.js
 */
import Vue from 'vue';
import App from '@/App';
import router from '@/router';
import store from '@/store/index.js';
import util from '@/lib/util';
import '@/lib/flexibel/flexible.debug.js';
import loginModel from '@/components/loginModel';
import smsVerify from '@/components/smsVerify';
import customerService from '@/components/customerService';
import picker from '@/components/picker';
import confirm from '@/components/confirm';
import maintain from '@/components/maintain';
// 路由 &&  添加标签
import '@/permission';

// 设置代码运行环境
store.commit('setEnv', process.env.VUE_APP_MY_NODE);

// 将 Toast 注入全局
import Toast from '@/lib/mint/toast';
import 'mint-ui/lib/style.css';
Toast.install = function(Vue) {
    Vue.prototype.$toast = Toast;
};
Vue.use(Toast);

import { MessageBox } from 'mint-ui';
MessageBox.install = function(Vue) {
    Vue.prototype.$message = MessageBox;
};
Vue.use(MessageBox);

// 将文本复制到粘贴板
import VueClipboard from 'vue-clipboard2';
VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);

import VueAnimateNumber from 'vue-animate-number'
Vue.use(VueAnimateNumber)

// 将 util 注入全局
Vue.prototype.$util = util;

// 将 loginModel 注入全局
Vue.prototype.$loginModel = loginModel;

// 将 smsVerify 注入全局
Vue.prototype.$smsVerify = smsVerify;

// 将 customerService 客服 注入全局
Vue.prototype.$customerService = customerService;

// 将 picker 注入全局
Vue.prototype.$picker = picker;

// 将 confirm 注入全局
Vue.prototype.$confirm = confirm;

// 将 confirm 注入全局
Vue.prototype.$maintain = maintain;

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
